var _defs, _rect, _path, _path2, _path3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelingElevationFromSurfaceSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#009ad9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingElevationFromSurface_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.68,
    y: 5.99,
    width: 0.08,
    height: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.74,23.46a5.31,5.31,0,0,0,1.57-2.6c.43-1.16.91-2.48,2.46-3.07s3.08.1,4.64.84a22.36,22.36,0,0,0,2.68,1.12,15.73,15.73,0,0,0,6.29.57L16.5,15.06l-16,8L3.67,24.6C5.94,24.72,7.65,24.35,8.74,23.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.72,27.77a5,5,0,0,0-1.83-.88c-1.07-.15-2.38.67-3.84,2.39L16.5,31l4.1-2.18A12.59,12.59,0,0,1,18.72,27.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.48,21.65a21.34,21.34,0,0,1-2.92-1.21c-1.5-.71-2.31-1.07-3.09-.77s-.89.81-1.28,1.88A7.3,7.3,0,0,1,10,25a7.05,7.05,0,0,1-2.86,1.32l4.07,2c2.09-2.58,4-3.72,6-3.45a6.64,6.64,0,0,1,2.62,1.17,5.89,5.89,0,0,0,3.36,1.24h0l.29,0,8-4.27-2.16-1.15A19,19,0,0,1,19.48,21.65Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15 6 15 4 15 0 17 0 17 4 17 6 17 9 20.32 9 15.99 14.11 11.73 9 15 9 15 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingElevationFromSurfaceSvg);
export default __webpack_public_path__ + "static/media/ModelingElevationFromSurface_svg.b65d461f4907a624555ef0d03e393a67.svg";
export { ForwardRef as ReactComponent };